module.exports = __webpack_public_path__ + "static/media/arles_thermen.b2787b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/arles_thermen.png
// module id = 707
// module chunks = 0